const isDev = process.env.NODE_ENV === 'development';

export const logError = (message, error) => {
  if (isDev) {
    console.error(message, error);
  }
};
